module.exports = __webpack_public_path__ + "img/2024-02_research-community.4d6ccdfd.jpg";